import { render, staticRenderFns } from "./AddSubnet.vue?vue&type=template&id=10b74aa8&"
import script from "./AddSubnet.vue?vue&type=script&lang=js&"
export * from "./AddSubnet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports